import React from 'react';
import FormButton from '@app/component/form/button/FormButton';

const options = [
	{ label: '7 days', value: 7 },
	{ label: '14 days', value: 14 },
	{ label: '1 Month', value: 30 },
	{ label: '2 Months', value: 60 },
	{ label: '3 Months', value: 90 },
	{ label: '4 Months', value: 120 },
	{ label: '5 Months', value: 150 },
];

const AlertTimeFrameField: React.FunctionComponent<{ form: any }> = ({ form }) => {

	const days = form.watch('timeframe.days');

	return <>
		<p className="text-sm font-semibold leading-6 text-gray-900 mb-2">
			Time Ahead
			<span
				className="ml-1 text-gray-500 font-light italic text-xs">
            (Select the time ahead from the starting date for the alert to scan)
    </span>
		</p>
		<div className="mt-2 grid grid-cols-3 gap-3 lg:grid-cols-7">
			{options
				.map((option: any, i: number) => <FormButton key={i} state={option.value == days ? 'primary' : 'white'}
																										 onClick={() => form.setValue('timeframe.days', option.value)}>
						{option.label}
					</FormButton>,
				)}
		</div>
	</>;
};

export default AlertTimeFrameField;